<template>
	<div class="view-container view-dashboard">
		<div class="libdash-layout" :class="{ 'one-column': hideExploreColumnOnDashboard }">
			<div>
				<div class="top-row">
					<h1 class="title">
						Welcome to Liberty
					</h1>
				</div>
				<div>
					<ai-promo-banner />
				</div>
				<div class="products-layout">
					<product-panel
						v-for="item in products"
						:key="item.component"
						:is_loading="is_loading"
						:data="item.data"
						:title="item.title"
						@request="requestAction"
					/>
				</div>
			</div>
			<div v-if="!is_loading" class="info-layout" :class="{ 'hide-explore-column': hideExploreColumnOnDashboard }">
				<div class="features-layout">
					<div class="top-row">
						<h2 class="title event">
							Explore
						</h2>
					</div>
					<promo-banner />
					<div class="features-container">
						<div class="feature-panel">
							<div class="feature-icon"></div>
							<a href="https://community.netcall.com" target="_blank">
								<h3 class="feature-title">Netcall Community</h3>
								<span class="cover"></span>
							</a>
							<div class="feature-text">
								Get help, support and custom code for your system
							</div>
						</div>
						<div class="feature-panel">
							<div class="feature-icon"></div>
							<a href="https://docs.netcall.com" target="_blank">
								<h3 class="feature-title">Documentation</h3>
								<span class="cover"></span>
							</a>
							<div class="feature-text">
								Help for all Liberty products in one place.
							</div>
						</div>
						<div class="feature-panel">
							<div class="feature-icon"></div>
							<a href="https://ideas.netcall.com" target="_blank">
								<h3 class="feature-title">Ideas</h3>
								<span class="cover"></span>
							</a>
							<div class="feature-text">
								Contribute and vote on the next new features.
							</div>
						</div>
						<div class="feature-panel">
							<div class="feature-icon"></div>
							<a href="https://forum.netcall.com/c/liberty-releases/23" target="_blank">
								<h3 class="feature-title">What’s New?</h3>
								<span class="cover"></span>
							</a>
							<div class="feature-text">
								Find about about the latest features across Liberty products.
							</div>
						</div>
						<div class="feature-panel">
							<div class="feature-icon"></div>
							<a href="https://community.netcall.com/appshare" target="_blank">
								<h3 class="feature-title">AppShare</h3>
								<span class="cover"></span>
							</a>
							<div class="feature-text">
								Customise your apps with tried and tested solutions.
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
	import { Options, Vue } from 'vue-class-component';
	import { HttpHelper } from '../helper/http';
	import AiPromoBanner from '../components/dashboard/AiPromoBanner.vue';
	import ProductPanel from '../components/dashboard/ProductPanel.vue';
	import AppSharePanel from '../components/dashboard/AppSharePanel.vue';
	import PromoBanner from '../components/PromoBanner.vue';

	@Options({
		name: 'Dashboard',
		components: { AiPromoBanner, ProductPanel, AppSharePanel, PromoBanner },
		inject: ['http'],
	})
	export default class DashboardNew extends Vue {
		public http!: HttpHelper;
		public is_loading = true;
		public products: any = [];
		public app_share_list: any = [];
		public slides = [
			{ title: 'Slide 1', text: 'Welcome to the first slide.', img: '/images/event-advert.png' },
			{ title: 'Slide 2', text: 'Here comes another one.' },
			{ title: 'Slide 3', text: 'Almost there!' },
		];

		public get hideExploreColumnOnDashboard(): boolean {
			return this.$store.state.configuration?.displaySettings?.hideExploreColumnOnDashboard || false;
		}

		public get topAppShare(): Record<string, string|number|null>|null {
			return this.app_share_list?.[0] || null;
		}

		public get appShareList(): Record<string, string|number|null>[]|[] {
			return this.app_share_list.slice(1);
		}

		public async requestDashboard(): Promise<void> {
			const response = await this.http.get('/api/dashboard');
			if (response.status === 200) {
				const responseData = await response.json();
				this.app_share_list = responseData.app_share;
				this.products = responseData.products;
				this.is_loading = false;
			}
		}

		public async requestAction(url: string): Promise<void> {
			await this.http.get(url);
			await this.requestDashboard();

			await this.loadConfiguration();

			this.is_loading = false;
		}

		public async loadConfiguration(): Promise<void> {
			const response = await this.http.get('/api/configuration', { autoRefresh: 'auto' });
			if (response.status === 200) {
				this.$store.dispatch('setConfiguration', await response.json());
			}
		}

		public async mounted(): Promise<void> {
			await this.requestDashboard();
		}
	}

</script>

<style lang="scss" scoped>
	@import '../assets/styles/base';

	.view-dashboard {
		background-image: url("data:image/svg+xml,%3Csvg id='Group_8082' data-name='Group 8082' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='490.126' height='655.365' viewBox='0 0 490.126 655.365'%3E%3Cdefs%3E%3CclipPath id='clip-path'%3E%3Crect id='Rectangle_3505' data-name='Rectangle 3505' width='490.126' height='655.365' fill='none'/%3E%3C/clipPath%3E%3C/defs%3E%3Cg id='Group_8081' data-name='Group 8081' clip-path='url(%23clip-path)'%3E%3Cpath id='Path_90' data-name='Path 90' d='M425.422,241.272c-74.767-43.167-103.746-135.32-69.39-211.963l-59.87,103.7c-31.691,54.891-12.535,125.4,42.71,157.3l151.254,87.326v-99Z' fill='%237085f3'/%3E%3Cpath id='Path_91' data-name='Path 91' d='M356.033,29.309,372.954,0h-1l-8.193,14.189a166.367,166.367,0,0,0-7.729,15.12' fill='%2392cccc'/%3E%3Cpath id='Path_92' data-name='Path 92' d='M296.162,133.008l59.87-103.7a166.364,166.364,0,0,1,7.731-15.119L371.955,0H255.166L203.357,89.736c-45.752,79.244-18.1,181.035,61.659,227.083l225.11,129.967V377.63L338.872,290.3c-55.245-31.9-74.4-102.406-42.71-157.3' fill='%237ea2e3'/%3E%3Cpath id='Path_93' data-name='Path 93' d='M203.357,89.735,255.166,0H45.492C-1.461,81.985-10.9,175.493,11.79,260.628A349.136,349.136,0,0,0,174.7,473.253L490.126,655.365V446.785L265.016,316.818C185.26,270.771,157.6,168.979,203.357,89.735' fill='%234863f0'/%3E%3C/g%3E%3C/svg%3E%0A");
		background-repeat: no-repeat;
		background-position: top 53px right 10px;
		background-attachment: fixed;
		background-size: 30%;
		margin-top: -20px;
		margin-right: -20px;
		max-width: unset;
		padding-left: 2rem;
		padding-top: 20px;
		padding-right: 20px;
		min-height: calc(100vh - 76px);
	}
	.libdash-layout {
		h1 {
			font-size: 36px;
			letter-spacing: -0.8px;
			margin: 0;
			padding: 0;
			span {
				color: $primary;
			}
		}
		h2 {
			font-size: 28px;
			font-weight: bold;
			letter-spacing: -0.8px;
			margin: 0;
			padding: 0;
		}
		.top-row {
			display: flex;
			align-items: flex-end;
			padding-top: 2rem;
			padding-bottom: 2rem;
			height: 60px;
		}
		.app-share-layout {
			position: relative;
			display: flex;
			flex-direction: column;
			.banner {
				display: block;
				width: 100%;
				height: 225px;
				border-radius: 0.5rem;
				overflow-y: hidden;
				margin-bottom: 1rem;
			}
			.app-share-list {
				display: flex;
				flex-direction: column;
				gap: 0.75rem;
			}
			a.app-share-link {
				font-size: 1.1rem;
				display: inline-flex;
			}
			.load-more {
				display: flex;
				justify-items: center;
				align-items: center;
				width: 100%;
				height: 30px;
				justify-content: center;
				margin-top: 1rem;
				.load-more-button {
					color: $primary-text-colour;
					font-weight: 600;
					border: 1px solid $primary-text-colour;
					padding: 10px 20px;
					border-radius: 20px;
					transition: all ease-in-out 0.5s;
					&:hover {
						color: white;
						background-color: $primary-text-colour;
						transition: all ease-in-out 0.3s;
					}
				}
			}
		}
		.features-layout {
			.banner {
				display: flex;
				align-items: flex-end;
				justify-content: center;
				background-color: #fecd03;
				width: 100%;
				height: 225px;
				border-radius: 0.5rem;
				overflow: hidden;
				margin-bottom: 1rem;
				> img {
					width: 100%;
					height: 100%;
					object-fit: contain;
					object-position: bottom right;
					display: block;
				}
//				.event {
//					background-repeat: no-repeat;
//					background-size: cover;
//					background-position: center center;
//					display: block;
//					width: 100%;
//					height: 100%;
//				}
			}

			.feature-panel {
				position: relative;
				display: grid;
				grid-template-rows: auto 1fr;
				grid-template-columns: 1fr 6fr;
				gap: 0;
				margin-bottom: 0.75rem;
				border: 1px solid rgba(72, 99, 240, 0.05);
				border-radius: 0.5rem;
				padding: 1rem;
				transition: 0.25s all ease-in-out;
				background-color: white;
				font-family: $primary-font-family;
				box-shadow: 0 3px 11px rgba(0, 0, 0, 0.05);
				&:hover {
					box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
					transform: translate(0px, -1px);
				}
				.feature-icon {
					background-repeat: no-repeat;
					background-size: contain;
					width: 32px;
					height: 32px;
				}
				.feature-title {
					font-size: 16px;
					font-weight: bold;
					color: #0A2F83;
					margin: 0.3rem 0;
				}
				.feature-text {
					font-size: 14px;
					color: $secondary-text-colour;
					grid-column-start: 2;
				}
				.cover {
					position: absolute;
					top: 0;
					bottom: 0;
					left: 0;
					right: 0;
				}

				&:nth-of-type(1) .feature-icon {
					background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='39' height='39' viewBox='0 0 39 39'%3E%3Crect id='Rectangle_3520' data-name='Rectangle 3520' width='39' height='39' rx='7' fill='%23a1aef5' opacity='0.247'/%3E%3Cpath id='Path_3296' data-name='Path 3296' d='M-6.75-11.25A2.5,2.5,0,0,0-4.585-12.5a2.5,2.5,0,0,0,0-2.5A2.5,2.5,0,0,0-6.75-16.25,2.5,2.5,0,0,0-8.915-15a2.5,2.5,0,0,0,0,2.5A2.5,2.5,0,0,0-6.75-11.25Zm-2,1.25a2.5,2.5,0,0,0-2.5,2.5A1.249,1.249,0,0,0-10-6.25h3.855A5.009,5.009,0,0,1-2.785-8.656,2.494,2.494,0,0,0-5-10ZM10-6.25A1.249,1.249,0,0,0,11.25-7.5,2.5,2.5,0,0,0,8.75-10H5A2.5,2.5,0,0,0,2.793-8.676,5.021,5.021,0,0,1,6.27-6.25Zm-5.266,0A3.744,3.744,0,0,0,2.5-7.457L2.43-7.469A4.046,4.046,0,0,0,1.941-7.5h-3.75a4.046,4.046,0,0,0-.488.031c-.066.008-.133.02-.2.031A3.717,3.717,0,0,0-4.6-6.25a3.735,3.735,0,0,0-.953,2.5A1.249,1.249,0,0,0-4.3-2.5h8.75A1.249,1.249,0,0,0,5.7-3.75a3.735,3.735,0,0,0-.953-2.5ZM7-11.25A2.5,2.5,0,0,0,9.165-12.5a2.5,2.5,0,0,0,0-2.5A2.5,2.5,0,0,0,7-16.25,2.5,2.5,0,0,0,4.835-15a2.5,2.5,0,0,0,0,2.5A2.5,2.5,0,0,0,7-11.25ZM.063-13.125a1.25,1.25,0,0,1,1.25,1.25,1.25,1.25,0,0,1-1.25,1.25,1.25,1.25,0,0,1-1.25-1.25A1.25,1.25,0,0,1,.063-13.125Zm-1.875,3.75A3.126,3.126,0,0,0,.063-8.75a3.126,3.126,0,0,0,1.875-.625,3.122,3.122,0,0,0,1.25-2.5A3.124,3.124,0,0,0,.063-15a3.124,3.124,0,0,0-3.125,3.125A3.122,3.122,0,0,0-1.812-9.375Zm5.52,5H-3.582a1.88,1.88,0,0,1,1.77-1.25h3.75A1.88,1.88,0,0,1,3.707-4.375ZM-12.5.313a.935.935,0,0,0,.938.938H11.563A.935.935,0,0,0,12.5.313a.935.935,0,0,0-.937-.937H-11.562A.935.935,0,0,0-12.5.313Z' transform='translate(20 27)' fill='%234863f0'/%3E%3C/svg%3E%0A");
				}

				&:nth-of-type(2) .feature-icon {
					background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='39' height='39' viewBox='0 0 39 39'%3E%3Crect id='Rectangle_3521' data-name='Rectangle 3521' width='39' height='39' rx='7' fill='%23a1aef5' opacity='0.247'/%3E%3Cpath id='Path_3297' data-name='Path 3297' d='M-9.793-17.344a.942.942,0,0,0-1.3.262.935.935,0,0,0,.262,1.3l1.875,1.25a.935.935,0,0,0,1.3-.262.934.934,0,0,0-.262-1.3l-1.875-1.25Zm20.625,1.563a.942.942,0,0,0,.262-1.3.941.941,0,0,0-1.3-.262l-1.875,1.25a.942.942,0,0,0-.262,1.3.941.941,0,0,0,1.3.262ZM-11.562-11.25a.935.935,0,0,0-.937.938.935.935,0,0,0,.938.938h2.5a.935.935,0,0,0,.938-.937.935.935,0,0,0-.937-.937Zm20.625,0a.935.935,0,0,0-.937.938.935.935,0,0,0,.938.938h2.5a.935.935,0,0,0,.938-.937.935.935,0,0,0-.937-.937ZM-7.918-4.531a.942.942,0,0,0,.262-1.3.941.941,0,0,0-1.3-.262l-1.875,1.25a.942.942,0,0,0-.262,1.3.941.941,0,0,0,1.3.262ZM8.957-6.09a.935.935,0,0,0-1.3.262.934.934,0,0,0,.262,1.3l1.875,1.25a.935.935,0,0,0,1.3-.262.934.934,0,0,0-.262-1.3ZM5-10.625a4.948,4.948,0,0,1-.891,2.848c-.145.207-.312.441-.5.691A22.878,22.878,0,0,0,2.059-4.75,6.5,6.5,0,0,0,1.344-2.5h1.9A4.479,4.479,0,0,1,3.7-3.852,19.363,19.363,0,0,1,5.051-5.875c.2-.277.406-.555.6-.836a6.838,6.838,0,0,0,1.227-3.918A6.88,6.88,0,0,0,0-17.5a6.875,6.875,0,0,0-6.875,6.875A6.828,6.828,0,0,0-5.648-6.707c.2.281.4.559.6.836A18.575,18.575,0,0,1-3.7-3.848,4.479,4.479,0,0,1-3.238-2.5h1.9a6.479,6.479,0,0,0-.715-2.246A22.878,22.878,0,0,0-3.609-7.082c-.184-.25-.352-.484-.5-.691A4.969,4.969,0,0,1-5-10.625a5,5,0,0,1,5-5A5,5,0,0,1,5-10.625Zm-6.875,0A1.875,1.875,0,0,1,0-12.5a.627.627,0,0,0,.625-.625A.627.627,0,0,0,0-13.75a3.124,3.124,0,0,0-3.125,3.125A.627.627,0,0,0-2.5-10,.627.627,0,0,0-1.875-10.625Zm5,10V-1.25h-6.25v.625A3.124,3.124,0,0,0,0,2.5,3.124,3.124,0,0,0,3.125-.625Z' transform='translate(19 27)' fill='%234863f0'/%3E%3C/svg%3E%0A");
				}

				&:nth-of-type(3) .feature-icon {
					background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='39' height='39' viewBox='0 0 39 39'%3E%3Crect id='Rectangle_3522' data-name='Rectangle 3522' width='39' height='39' rx='7' fill='%23a1aef5' opacity='0.247'/%3E%3Cpath id='Path_3298' data-name='Path 3298' d='M-8.75-14.062A3.438,3.438,0,0,1-5.312-17.5H6.563A2.189,2.189,0,0,1,8.75-15.312v11.25A2.191,2.191,0,0,1,7.5-2.086V.625h.313a.938.938,0,0,1,0,1.875H-5.625A3.124,3.124,0,0,1-8.75-.625a2.745,2.745,0,0,1,.016-.312H-8.75V-14.062ZM-5.625-1.875a1.249,1.249,0,0,0-1.25,1.25A1.249,1.249,0,0,0-5.625.625H5.625v-2.5Zm-1.25-1.613a3.1,3.1,0,0,1,1.25-.262H6.563a.313.313,0,0,0,.313-.312v-11.25a.313.313,0,0,0-.312-.312H-5.312a1.562,1.562,0,0,0-1.563,1.563Zm4.063-9.637H4.063A.935.935,0,0,1,5-12.187a.935.935,0,0,1-.937.938H-2.812a.935.935,0,0,1-.937-.937A.935.935,0,0,1-2.812-13.125Zm0,3.125H4.063A.935.935,0,0,1,5-9.062a.935.935,0,0,1-.937.938H-2.812a.935.935,0,0,1-.937-.937A.935.935,0,0,1-2.812-10Z' transform='translate(20 26)' fill='%234863f0'/%3E%3C/svg%3E%0A");
				}

				&:nth-of-type(4) .feature-icon {
					background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='39' height='39' viewBox='0 0 39 39'%3E%3Crect id='Rectangle_3523' data-name='Rectangle 3523' width='39' height='39' rx='7' fill='%23a1aef5' opacity='0.247'/%3E%3Cpath id='Path_3299' data-name='Path 3299' d='M-2.176-14.316A2.459,2.459,0,0,1,0-15.625a2.459,2.459,0,0,1,2.176,1.309.938.938,0,0,0,1.105.457,2.46,2.46,0,0,1,2.465.613,2.47,2.47,0,0,1,.613,2.465.931.931,0,0,0,.457,1.1A2.459,2.459,0,0,1,8.125-7.5,2.459,2.459,0,0,1,6.816-5.328a.933.933,0,0,0-.457,1.1,2.46,2.46,0,0,1-.613,2.465,2.47,2.47,0,0,1-2.465.613.931.931,0,0,0-1.1.457A2.459,2.459,0,0,1,0,.617,2.459,2.459,0,0,1-2.172-.691a.933.933,0,0,0-1.1-.457,2.46,2.46,0,0,1-2.465-.613,2.46,2.46,0,0,1-.621-2.457.931.931,0,0,0-.457-1.1A2.47,2.47,0,0,1-8.125-7.5,2.459,2.459,0,0,1-6.816-9.676a.938.938,0,0,0,.457-1.105,2.46,2.46,0,0,1,.613-2.465,2.47,2.47,0,0,1,2.465-.613.931.931,0,0,0,1.1-.457ZM0-17.5a4.33,4.33,0,0,0-3.441,1.7A4.332,4.332,0,0,0-7.074-14.57a4.332,4.332,0,0,0-1.234,3.633A4.325,4.325,0,0,0-10-7.5,4.33,4.33,0,0,0-8.3-4.059,4.332,4.332,0,0,0-7.07-.426,4.332,4.332,0,0,0-3.438.809,4.325,4.325,0,0,0,0,2.5,4.33,4.33,0,0,0,3.441.8,4.332,4.332,0,0,0,7.074-.43,4.332,4.332,0,0,0,8.309-4.062,4.325,4.325,0,0,0,10-7.5a4.33,4.33,0,0,0-1.7-3.441A4.332,4.332,0,0,0,7.07-14.574a4.332,4.332,0,0,0-3.633-1.234A4.325,4.325,0,0,0,0-17.5ZM4.414-9.336a.934.934,0,0,0,0-1.324.937.937,0,0,0-1.324,0L-1.246-6.324-3.082-8.16a.934.934,0,0,0-1.324,0,.937.937,0,0,0,0,1.324l2.5,2.5a.934.934,0,0,0,1.324,0Z' transform='translate(20 27)' fill='%234863f0'/%3E%3C/svg%3E%0A");
				}
				&:nth-of-type(5) .feature-icon {
					background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='39' height='39' viewBox='0 0 39 39'%3E%3Crect id='Rectangle_3523' data-name='Rectangle 3523' width='39' height='39' rx='7' fill='%23a1aef5' opacity='0.247'/%3E%3Cpath id='Path_3300' data-name='Path 3300' d='M-5.387,2.188a2.262,2.262,0,0,1-1.6-.664l-4.7-4.7a1.691,1.691,0,0,1-.5-1.2,1.691,1.691,0,0,1,.5-1.2l4.7-4.7a2.262,2.262,0,0,1,1.6-.664A2.261,2.261,0,0,1-3.125-8.676v.238h7.5A.627.627,0,0,1,5-7.812v1.488a.388.388,0,0,0,.387.387.378.378,0,0,0,.273-.113l4.578-4.574L5.664-15.2a.384.384,0,0,0-.273-.113A.388.388,0,0,0,5-14.926v1.488a.627.627,0,0,1-.625.625H0a.935.935,0,0,1-.937-.937A.935.935,0,0,1,0-14.687H3.125v-.238a2.261,2.261,0,0,1,2.262-2.262,2.262,2.262,0,0,1,1.6.664l4.7,4.7a1.691,1.691,0,0,1,.5,1.2,1.691,1.691,0,0,1-.5,1.2l-4.7,4.7a2.262,2.262,0,0,1-1.6.664A2.261,2.261,0,0,1,3.125-6.324v-.238h-7.5A.627.627,0,0,1-5-7.187V-8.676a.388.388,0,0,0-.387-.387.378.378,0,0,0-.273.113l-4.578,4.574L-5.664.2a.384.384,0,0,0,.273.113A.388.388,0,0,0-5-.074V-1.562a.627.627,0,0,1,.625-.625H0a.935.935,0,0,1,.938.938A.935.935,0,0,1,0-.312H-3.129v.238A2.261,2.261,0,0,1-5.391,2.188Z' transform='translate(20 27)' fill='%234863f0'/%3E%3C/svg%3E%0A");
				}
			}
		}
	}

	.libdash-layout {
		display: grid;
		grid-template-columns: 1f;
		gap: 2rem;
		max-width: 550ch;
	}
	.products-layout {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		@media screen and (max-width: 990px) {
			grid-template-columns: 1fr 1fr;
		}
		@media screen and (max-width: 576px) {
			grid-template-columns: 1fr;
		}

		gap: 2rem;
		padding: 1rem;
		background-color: rgba(232, 232, 232, 0.9);
		border-radius: 0.5rem;
	}
	.info-layout {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(min(200px, 100%), 1fr));
		gap: 2rem;
	}

	@media (min-width: 1200px) {
		.libdash-layout {
			display: grid;
			grid-template-columns: 7fr 300px;
			gap: 2rem;
			// margin-right: 150px;
			.ai-banner .ai-grid {
				display: grid;
				grid-template-columns: 4fr 6fr;
				gap: 1rem;
			}
			&.one-column {
				grid-template-columns: 1fr;
			}
		}
		.event {
			color: white; /* Explore text to white in 1200px+ */
		}
	}
	@media (max-width: 1200px) {
		.libdash-layout {
			display: grid;
			grid-template-columns: 1fr;
		}
		.features-layout {
			display: grid;
			grid-template-columns: 300px 1fr;
			@media screen and (max-width: 760px) {
				grid-template-columns: 1fr;
			}
			gap: 2rem;
			.top-row {
				display: none;
			}
			.features-container {
				display: grid;
				grid-template-columns: 1fr 1fr;
				gap: 1rem;
				@media screen and (max-width: 990px) {
					grid-template-columns: 1fr;
				}
			}
		}
	}

	.hide-explore-column {
		display: none;
	}
</style>
